import type { Error } from '../types';
import { IBAN_VALIDATION } from '../utils/regex';

export const validateIbanCharacters =
  (message: Error['message']) =>
  (value: string): Error => ({
    valid: IBAN_VALIDATION.test(value),
    message
  });
